const addCategoryAction = (data) => ({
    type: "ADD_CATEGORY",
    payload: data, 
  });
  
  export { addCategoryAction };
  